import { lazy } from 'react';
import { useParams } from 'react-router';
import { useSurrenderDetails } from 'src/apis/monolith/use-surrender-details';
import { PageSpinner } from 'src/components/spinner-container';

const Page = lazy(() => import('./page'));

export const LegacySurrenderDetails = () => {
  const { surrenderId } = useParams<{ surrenderId: string }>();
  const surrender = useSurrenderDetails({ surrenderId });

  if (!surrender.response) return <PageSpinner />;

  return <Page surrender={surrender} />;
};
